const Blog = (posts) => {
    const view = posts.posts
      .map((post) => {
        const image = !post['item-thumbnail']
          ? ''
          : `<div class="image-holder"><a href="${post['item-permalink']}">${post['item-thumbnail']}</a></div>`;

        const author = post['item-author-link']
          ? `<li><span class="author"><a href="${post['item-author-link']}">${post['item-author']}</a></span></li>`
          : `<li><span class="author">${post['item-author']}</span></li>`;
          
        return `
                <div class="post-excerpt">
			            <div class="blog-post clearfix">
                    <div class="excerpt-title">
                      <div class="title-wrap">
                        <h2 class="post-title"><a href="${post['item-permalink']}" aria-label="${post['item-title']}">${post['item-title']}</a></h2>                    
                      </div>
                      <ul class="post-meta">
                        ${author}
                        <li><time class="month" datetime="${post['item-time']}">${post['item-time']}</time></li>
                        <li><span class="post-category">${post['item-categories']}</span></li>
                      </ul>
						        </div>
                    <div class="post-wrap">
                      ${image}
                      <div class="info-holder">
                        <div class="excerpt-content">
                          <p>${post['item-excerpt']}</p>
                        </div>
                        <div class="btn-wrapper">
                          <a href="${post['item-permalink']}" class="btn btn-line" aria-label="Continue Reading">Continue Reading</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
          `;
      })
      .join('');
  
    return view;
  };
  
  export default Blog;